import { useState } from 'react'
import { Link } from 'react-router-dom'
import { InfoIcon } from '@/shared/ui/icons/InfoIcon'
import { CheckIcon } from '@/shared/ui/icons/CheckIcon'
import { AlertIcon } from '@/shared/ui/icons/AlertIcon'
import { LoadingSpinner } from '@/shared/ui/LoadingSpinner'
import { buttonStyles } from '@/shared/ui/Button'
import { SubmitResultScreen } from '@/shared/ui/SubmitResultScreen'
import { ROW_CLASS } from '@/shared/ui/buttonRow'

export function Analyzing() {
  return (
    <SubmitResultScreen
      icon={<LoadingSpinner />}
      title="AI가 분석 후 등록됩니다."
      titleWeight="semibold"
      description="문제가 있을 시 수정이 필요할 수 있어요."
      gap={70}
    />
  )
}
export function RevisionNeeded({ reasons }: { reasons: string[] }) {
  return (
    <SubmitResultScreen
      icon={
        <span className="text-[#f54550]">
          <AlertIcon />
        </span>
      }
      title="수정이 필요합니다."
      titleWeight="semibold"
      description="아래 버튼을 누르면 수정이 필요한 화면으로 이동합니다."
      gap={40}
    >
      {reasons.length > 0 && (
        <ul className="m-0 flex list-none flex-col gap-1 p-0">
          {reasons.map((text) => (
            <li key={text} className="text-body-md text-violet-600">
              {text}
            </li>
          ))}
        </ul>
      )}
    </SubmitResultScreen>
  )
}
export function RevisionButtons({ onRevise, rowClass = ROW_CLASS }: { onRevise: () => void; rowClass?: string }) {
  return (
    <div className={rowClass}>
      <Link className={buttonStyles('lg', 'assistive', 'ui-pressable w-[90px] shrink-0 justify-center px-[22px] py-3 no-underline')} to="/">
        홈으로
      </Link>
      <button
        type="button"
        className={buttonStyles('lg', 'primary', 'ui-pressable min-w-0 flex-1 shrink-0 grow basis-0')}
        onClick={onRevise}
      >
        수정하러 가기
      </button>
    </div>
  )
}
export function Done({
  editLinkPath,
  isEdit = false,
}: {
  editLinkPath: string | null
  isEdit?: boolean
}) {
  return (
    <SubmitResultScreen
      icon={<CheckBadge />}
      title={isEdit ? '문제가 수정되었어요.' : '문제가 등록되었어요.'}
      titleWeight="semibold"
      description={
        isEdit ? '다시 검수한 뒤 공개돼요.' : '잘 맞는 기업을 찾으면 알려드릴게요.'
      }
      gap={40}
    >
      {editLinkPath !== null && <EditLink path={editLinkPath} />}
    </SubmitResultScreen>
  )
}
export function CheckBadge() {
  return (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-[99px] bg-violet-500 text-white-50 [&>svg]:h-4 [&>svg]:w-4">
      <CheckIcon />
    </span>
  )
}
export function EditLink({ path }: { path: string }) {
  const [copied, setCopied] = useState(false)
  const url = `${window.location.origin}${path}`

  const copy = () => {
    void navigator.clipboard
      ?.writeText(url)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
      })
      .catch(() => setCopied(false))
  }

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-caption font-medium text-black-800">수정 링크</span>
      <div className="flex h-11 items-center gap-2 rounded-lg bg-white-200 px-3 py-2">
        <span className="min-w-0 flex-1 shrink-0 grow basis-0 overflow-hidden text-ellipsis whitespace-nowrap text-body-md text-black-600">{url}</span>
        <button type="button" className="ui-pressable h-7 shrink-0 cursor-pointer rounded-md border border-white-400 bg-white-50 px-2 text-label font-medium whitespace-nowrap text-black-600" onClick={copy}>
          {copied ? '복사했어요' : '링크 복사'}
        </button>
      </div>
      <p className="m-0 flex items-center gap-1 text-label font-medium text-violet-600 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0">
        <InfoIcon />
        <span>수정은 해당 링크에서만 가능해요.</span>
      </p>
    </div>
  )
}
export function DoneButtons({ rowClass = ROW_CLASS }: { rowClass?: string } = {}) {
  return (
    <div className={rowClass}>
      <Link className={buttonStyles('lg', 'assistive', 'ui-pressable min-w-0 flex-1 shrink-0 grow basis-0 justify-center no-underline')} to="/">
        홈으로
      </Link>
    </div>
  )
}
